import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import CommitteeVoteType from './committee-vote/committee-vote-type';
import CommitteeVote from './committee-vote/committee-vote';
import { Mutable } from '../../types/mutable';
@Component({
    selector: 'committee-votes',
    templateUrl: './committee-votes.component.html',
    styleUrls: ['./committee-votes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeVotesComponent implements OnInit {
  @Input('voteTypes') voteTypes: CommitteeVoteType[];
  @Input('votes') votes: CommitteeVote[];
  @Input('projectId') projectId: string;
  @Input('milestoneId') milestoneId: string;
  @Input('milestoneName') milestoneName: string;
  @Input('projectDates') projectDates: Array<any>;
  @Input('readOnly') readOnly: boolean;

  public sortedVoteTypes: CommitteeVoteType[];
  constructor() {}

  ngOnInit(): void {
    this.handleVotesByMilestone();
    this.sortedVoteTypes = this.sorted();
    console.log(this.sortedVoteTypes)

  }

  getVoteForType(type: CommitteeVoteType): CommitteeVote | undefined {
    if (this.votes && this.voteTypes) {
      let filtered = this.votes.filter(
        (vote) =>
          vote.committeeVoteType?.id === type.id &&
          vote.milestone_id === this.milestoneId
      );
      if (filtered.length) {
        return filtered[0];
      }
    }
    return undefined;
  }
  getTally(type: boolean | null): number {
    let tally = 0;
    this.sortedVoteTypes.forEach((voteType) => {
      let vote = this.getVoteForType(voteType);
      if (vote && vote.status === type) {
        tally += 1;
      } else if (!vote && type === null) {
        tally += 1;
      }
    });
    return tally;
  }
  handleVoteUpdated(vote: CommitteeVote) {
    let votes: Mutable<CommitteeVote[]> = [...this.votes];
    let index = votes.findIndex((iVote: CommitteeVote) => vote.id === iVote.id);
    if (index > -1) {
      votes[index] = vote;
    } else {
      votes.push(vote);
    }
    this.votes = votes;
  }
  sorted(): CommitteeVoteType[] {
    const dates: Date[] = this.projectDates.length
      ? this.projectDates.map((projectDate) => new Date(projectDate.date))
      : [new Date()];
    this.voteTypes = this.voteTypes.filter((type) =>
      dates.some((date) => this.isActiveOn(type, date))
    );

    return [...this.voteTypes].sort(
      (a, b) => (a.pivot?.index ?? 0) - (b.pivot?.index ?? 0)
    );
  }

  isActiveOn(type: CommitteeVoteType, date: Date): boolean {
    const start = type.pivot?.start_date ? new Date(type.pivot.start_date) : null;
    const end = type.pivot?.end_date ? new Date(type.pivot.end_date) : null;
    return (start === null || start <= date) && (end === null || date <= end);
  }

  handleVotesByMilestone(){
    if(this.milestoneName.toLowerCase()=='closed'){
      this.votes = this.votes.filter((vote) => vote.committeeVoteType?.name=='Legal')
      this.voteTypes = this.voteTypes.filter((vote) => vote.name=='Legal');
    }
  }
}
